/* This code defines a JavaScript object `types` that contains a set of constants used as action types
in a Redux application. Each constant represents a specific action that can be dispatched to the
Redux store. The constants are used to ensure consistency and avoid typos when dispatching actions.
The object is then exported as the default export of the module. */
const types = {
  ADD_TOKEN: "ADD_TOKEN",
  ADD_ERROR: "ADD_ERROR",
  UPDATE_USER_WINS: "UPDATE_USER_WINS",
  UPDATE_USER_LOSSES: "UPDATE_USER_LOSSES",
  LOAD_USER_INFO: "LOAD_USER_INFO",
  MODIFY_SHIP_LENGTH: "MODIFY_SHIP_LENGTH",
  MODIFY_SELECTED_SQUARES: "MODIFY_SELECTED_SQUARES",
  MODIFY_SHIP_ORIENTATION: "MODIFY_SHIP_ORIENTATION",
  UPDATE_LAST_ACTIVE_SQUARE: "UPDATE_LAST_ACTIVE_SQUARE",
  UPDATE_SHIP_LOCATIONS: "UPDATE_SHIP_LOCATIONS",
  DELETE_SHIP_LENGTH: "DELETE_SHIP_LENGTH",
  RESET_GAME_BOARD: "RESET_GAME_BOARD",
  START_GAME: "START_GAME",
  UPDATE_SHIP_COORDINATES: "UPDATE_SHIP_COORDINATES",
  DELETE_FROM_SHIP_COORDINATES: "DELETE_FROM_SHIP_COORDINATES",
  FLIP_USER_MISS: "FLIP_USER_MISS",
  RESET_GAME: "RESET_GAME",
  NEXT_COMPUTER_MOVE: "NEXT_COMPUTER_MOVE",
  UPDATE_SHIP_INDEX: "UPDATE_SHIP_INDEX",
  DELETE_USER_SHIP_COORDINATE: "DELETE_USER_SHIP_COORDINATE",
  UPDATE_LAST_HIT: "UPDATE_LAST_HIT",
  SET_MESSAGE: "SET_MESSAGE",
  USER_MESSAGE: "USER_MESSAGE",
  COMPUTER_MESSAGE: "COMPUTER_MESSAGE",
  SET_COMPUTER_TURN: "SET_COMPUTER_TURN",
  ADD_TO_SUNK_SHIPS: "ADD_TO_SUNK_SHIPS",
  SET_GAME_SAVED: "SET_GAME_SAVED",
  LOAD_GAME: "LOAD_GAME",
  ADD_TO_USER_SELECTIONS: "ADD_TO_USER_SELECTIONS",
  SAVE_GAME: "SAVE_GAME",
  ADD_TO_COMPUTER_SUNK_SHIPS: "ADD_TO_COMPUTER_SUNK_SHIPS",
};

export default types;
